import React from "react";
import { Select, Form, Row, Col } from "antd";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledTextArea from "../../components/ControlledTextArea";
const { Option } = Select;

const AddTestForm = ({ control, options = {}, watch, errors }) => {
  const {
    testCategories = [],
    commodityCategories = [],
    commodities = [],
    currencies = [],
  } = options;

  const getOptions = (entries, key = "name") => {
    const opts = [];
    if (entries?.length) {
      entries.forEach((entry) => {
        opts.push(
          <Option key={entry._id} value={entry._id}>
            {entry[key]}
          </Option>
        );
      });
    }
    return opts;
  };

  const selectedCommodityCategory = watch("commodityCategory");

  return (
    <Form colon={false}>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="commodityCategory"
            label="Select Commodity Category"
            options={getOptions(commodityCategories)}
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="commodity"
            label="Select Commodity"
            options={
              selectedCommodityCategory
                ? getOptions(
                    commodities.filter(
                      ({ category }) => category === selectedCommodityCategory
                    )
                  )
                : []
            }
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="testCategory"
            label="Select Test Category"
            options={getOptions(testCategories)}
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="parameter"
            label="Enter Test Parameter"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledTextArea
            control={control}
            name="description"
            label="Description"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <ControlledSelect
            required
            control={control}
            name="currency"
            label="Currency"
            options={getOptions(currencies, "label")}
            errors={errors}
          />
        </Col>
        <Col span={12}>
          <ControlledInput
            required
            control={control}
            name="amount"
            label="Enter Price"
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddTestForm;
